import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { ReactionState, ClickReactionPayload, Reaction } from '@/types/reactions'
import { RootState } from '@/store'
import { ContentService } from '@/lib/api/services/content'

const initialState: ReactionState = {
  reactionButtons: [
    {
      reactionId: 1,
      name: 'いいね',
      class: 'good',
      count: 0,
      clicked: false,
    },
    {
      reactionId: 2,
      name: 'スキ',
      class: 'like',
      count: 0,
      clicked: false,
    },
    {
      reactionId: 3,
      name: 'わくわく',
      class: 'excited',
      count: 0,
      clicked: false,
    },
    {
      reactionId: 4,
      name: 'スゴい！',
      class: 'amazing',
      count: 0,
      clicked: false,
    },
    {
      reactionId: 5,
      name: '学びがある',
      class: 'lerning',
      count: 0,
      clicked: false,
    },
  ],
}

// API呼び出しを含むasync action
export const clickReactionAsync = createAsyncThunk(
  'reaction/clickReaction',
  async (payload: ClickReactionPayload, { getState, rejectWithValue }) => {
    const state = getState() as RootState
    const reaction = state.reaction.reactionButtons[payload.index]

    if (!reaction) {
      return rejectWithValue('Reaction not found')
    }

    // 現在の状態を確認
    const currentClicked = reaction.clicked

    try {
      // clickedの状態で処理分岐
      if (!currentClicked) {
        // POST
        await ContentService.postReaction(payload.storyId, payload.id)
      } else {
        // DELETE
        await ContentService.deleteReaction(payload.storyId, payload.id)
      }
      return payload
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const reactionSlice = createSlice({
  name: 'reaction',
  initialState,
  reducers: {
    setReactions: (state, action: PayloadAction<Reaction[]>) => {
      action.payload.forEach((reaction) => {
        const target = state.reactionButtons.find((r) => r.reactionId === reaction.reactionId)
        if (target) {
          target.count = reaction.count
          target.clicked = reaction.clicked
        }
      })
    },
    clickReaction: (state, action: PayloadAction<ClickReactionPayload>) => {
      const { index } = action.payload
      const reaction = state.reactionButtons[index]
      if (reaction) {
        if (!reaction.clicked) {
          reaction.count += 1
          reaction.clicked = true
        } else {
          reaction.count -= 1
          reaction.clicked = false
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clickReactionAsync.fulfilled, (state, action) => {
        // API成功後に状態を更新
        const { index } = action.meta.arg
        const reaction = state.reactionButtons[index]
        if (reaction) {
          if (!reaction.clicked) {
            reaction.count += 1
            reaction.clicked = true
          } else {
            reaction.count -= 1
            reaction.clicked = false
          }
        }
      })
      .addCase(clickReactionAsync.rejected, (state, action) => {
        process.env.NODE_ENV === 'development' &&
          console.error('Reaction API failed:', action.error)
      })
  },
})

export const { setReactions, clickReaction } = reactionSlice.actions

export const selectReactionButtons = (state: RootState) => state.reaction.reactionButtons

export default reactionSlice.reducer
